import { Select } from "antd";
import { OptionType } from "../StaticDropdown";
import {
  CustomStaticDropdownProps,
  DropdownItem,
} from "../../../Interfaces/dropdownInterfaces";
import { matchesDropdownSearch } from "src/Utils/dropdownSearch";

const CustomStaticDropdown = <T extends DropdownItem>({
  dropdown,
  onChange,
  options,
  value,
}: CustomStaticDropdownProps<T>) => {
  const getSelectedOption = (val: string): T | null =>
    options.find((o) => o.id === val) || null;

  const OnDropChange = (value: string) => {
    if (value) onChange(dropdown.name, getSelectedOption(value));
    else onChange(dropdown.name, null);
  };

  const GetValue = (v: T | null | undefined): string | null => {
    console.log({ v });
    if (!v) return null;
    if (!v?.id) return null;

    if (!options) return null;

    const res = options.find((x) => x.id === v.id)?.name || null;
    return res ? res : null;
  };

  const getOptions = () => {
    const res: any = [];
    options.map((option) => {
      const newOption = {
        value: option.id,
        label: option.name,
      };
      res.push(newOption);
    });
    return res;
  };

  const filterOption: (inputValue: string, option?: OptionType) => boolean = (
    inputValue,
    option,
  ) => {
    if (!option) {
      return true;
    }

    return matchesDropdownSearch(option.label, inputValue);
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-1">
      {dropdown.extraLabel ? (
        <div className="text-xs">{dropdown.placeholder}</div>
      ) : (
        <></>
      )}
      <Select
        allowClear
        style={{ width: "100%" }}
        showSearch
        placeholder={dropdown.placeholder}
        optionFilterProp="children"
        onChange={OnDropChange}
        // onSearch={onSearch}
        filterOption={filterOption}
        options={getOptions()}
        value={GetValue(value)}
        onClear={() => OnDropChange("")}
        disabled={dropdown.disabled}
      />
    </div>
  );
};

export default CustomStaticDropdown;
